import axios from 'axios';
import { decryptData } from './encrypt';
import { getCookie, deleteCookie, removeAllLocalStorage } from '../composables';

let globalToken = null; // Global variable to store the decrypted token

export function getGlobalToken() {
  return globalToken;
}

export default function interceptorSetup() {
  axios.interceptors.request.use(
    function (config) {
      let mkLocalData = getCookie('token');
      let pwdResetToken = getCookie('pwdResetToken');
      if (!mkLocalData) {
        mkLocalData = 'null';
      }
      mkLocalData = !pwdResetToken ? mkLocalData : pwdResetToken;
      const secretTokenKey = process.env.KEY || 'myscecretkey';
      const token = decryptData(mkLocalData, secretTokenKey);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        globalToken = token; // Store the token globally
        localStorage.setItem('authToken', token); // Store token in localStorage for persistence
        // console.log('Actual token:', token);
      }

      return config;
    },
    function () {
      return Promise.reject();
    }
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Error
      const {
        response: { status },
      } = error;

      // const { config, response: { status } } = error;

      if (status === 401) {
        // Unauthorized request: maybe access token has expired!
        //return refreshAccessToken(config);
       //  axios
       // 
       // .post('http://94.237.2.122:8080/api/', null)
        // .post('http://localhost/HR_Engine/api', null)
          // axios.post('http://10.10.20.208/HR_Engine/api/', null)
          axios.post('https://theportal.stratacache-apac.com/api', null)
          .then(() => {
            this.$router.push({ path: '/' });
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            // localStorage.removeItem('token');
            deleteCookie('token');
            deleteCookie('2faToken');
            removeAllLocalStorage();
            location.reload();
          });
      } else {
        return Promise.reject(error);
      }
    }
  );
}
